import { Goal } from '@griply/types';

export const filterGoalsBySearchText = (
  goals: Goal[],
  searchText: string,
): Goal[] => {
  if (!searchText) {
    return [];
  }
  const trimmedSearchText = searchText.trim().toLowerCase();

  return goals
    .filter(({ name }) => name.toLowerCase().includes(trimmedSearchText))
    .sort((a, b) => a.name.localeCompare(b.name));
};
